<template>
  <v-app id="inspire">
    <v-app-bar
        app
        :color="bg"
    >
      <v-spacer></v-spacer>
      <v-toolbar-title><v-img src="/static/logo_examenis.png" max-width="150"></v-img></v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>


<script>
export default {
  name: 'App',
  components: {},
  data: () => ({
    bg:''
    //
  }),
  mounted() {
    window.onscroll = () => {
      this.changeColor();
    };
  },
  methods: {
    changeColor() {
      if (
          document.body.scrollTop > 50 ||
          document.documentElement.scrollTop > 50
      ) {
        this.bg = 'white';
      } else {
        this.bg = 'transparent';
      }
    },
  },
};
</script>
